import DateCalendar from "./DateCalendar";
import DatePicker from "./DatePicker";
import DateTimePicker from "./DateTimePicker";
import DateTimePickersLocalizationProvider from "./DateTimePickersLocalizationProvider";
import MultiInputDateRangeField from "./MultiInputDateRangeField";
import StaticDateRangePicker from "./StaticDateRangePicker";
import DateRangePicker from "./DateRangePicker";

/**
 * if testing, check the following:
 * @see https://github.com/mui/material-ui-pickers/issues/2073
 */

const DateTimePickers = {
  DateCalendar,
  DatePicker,
  DateTimePicker,
  LocalizationProvider: DateTimePickersLocalizationProvider,
  MultiInputDateRangeField,
  StaticDateRangePicker,
  DateRangePicker,
};
export default DateTimePickers;

export type { DateRange, DateRangeValidationError, MultiInputDateRangeFieldProps } from "@mui/x-date-pickers-pro";
